import React from 'react'
import './cardItem.scss'

export default function CardItem({ heading, children, style }) {
    if(heading) {
        return (
            <div style={style}>
                <span className='promo-info-subheading'>{ heading }</span>
                <br/>{ children }
            </div>
        )
    }
    return null
}